export function extractS3ObjectKeyFromUrl(url) {
  if (!url || typeof url !== 'string') return null;
  if (url.startsWith('data:') || url.startsWith('blob:')) return null;

  try {
    const u = new URL(url);
    const host = (u.hostname || '').toLowerCase();
    let path = u.pathname || '';
    if (path.startsWith('/')) path = path.slice(1);
    if (!path) return null;

    if (host.includes('amazonaws.com')) {
      const parts = path.split('/').filter(Boolean);
      if (!parts.length) return null;

      // path-style: https://s3.{region}.amazonaws.com/{bucket}/{key}
      if (host.startsWith('s3.') || host === 's3.amazonaws.com' || host.startsWith('s3-')) {
        if (parts.length >= 2) return decodeURIComponent(parts.slice(1).join('/'));
        return null;
      }

      // virtual-hosted-style: https://{bucket}.s3.{region}.amazonaws.com/{key}
      return decodeURIComponent(path);
    }

    return null;
  } catch {
    return null;
  }
}


